<template>
  <v-card>
    <v-card-title>
      {{ $t('lds.addDate') }}
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.name"
              :label="$t('common.name')"
              counter="64"
              dense
              outlined
              :error-messages="errorMessages('name')"
              @change="$v.form.name.$touch()"
            />
          </v-col>
          <v-col>
            <VfDateInput
              v-model="form.date"
              :label="$t('lds.date')"
              outlined
              dense
              :error-messages="errorMessages('date')"
              @change="$v.form.date.$touch()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-textarea
            v-model="form.description"
            :label="$t('common.description')"
            dense
            outlined
            counter="128"
            rows="2"
            :error-messages="errorMessages('description')"
            @change="$v.form.description.$touch()"
          />
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        rounded
        dark
        dense
        outlined
        color="primary"
        @click="handleCancel"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <SubmitButton @click="handleSubmit" />
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { DEFAULT_LD_DATE } from '../../helpers'
import { errorMessageGenerator, liquidatedDamageDateModel } from '../../validators'

export default {
  name: 'LiquidatedDamagesDateForm',
  props: {
    liquidatedDamage: Object,
    date: Object,
    part: Object,
    currencies: Array
  },
  data () {
    return {
      form: _.cloneDeep(this.getInitialDate())
    }
  },
  computed: {
    currency () {
      const currency = this.part ? this.currencies.find(currency => currency.key === this.part.currency) : this.currencies[0]
      return { ...currency, value: 1 }
    }
  },
  methods: {
    getInitialDate () {
      return this.date || DEFAULT_LD_DATE
    },
    handleCancel () {
      this.$eventBus.$emit('CLOSE_MODAL')
    },
    async handleSubmit () {
      await this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('SAVE_LD_DATE', { ...this.form, liquidatedDamageId: this.liquidatedDamage.id })
        this.$eventBus.$emit('CLOSE_MODAL')
      }
    },
    errorMessages (key) {
      return errorMessageGenerator(this.$v.form[key], key)
    }
  },
  validations: liquidatedDamageDateModel
}
</script>
